var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrownPro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3333 7.85845V20.6318C29.3333 24.3118 26.3467 27.2984 22.6667 27.2984H9.33335C8.72001 27.2984 8.13335 27.2184 7.56001 27.0584C6.73335 26.8318 6.46668 25.7784 7.08001 25.1651L21.2533 10.9918C21.5467 10.6984 21.9867 10.6318 22.4 10.7118C22.8267 10.7918 23.2933 10.6718 23.6267 10.3518L27.0533 6.91178C28.3067 5.65845 29.3333 6.07178 29.3333 7.85845Z",
    fill: "#14904A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.52 10.0585L5.55996 24.0185C4.91996 24.6585 3.85329 24.4985 3.42663 23.6985C2.93329 22.7918 2.66663 21.7385 2.66663 20.6318V7.85848C2.66663 6.07181 3.69329 5.65848 4.94663 6.91181L8.38663 10.3651C8.90663 10.8718 9.75996 10.8718 10.28 10.3651L15.0533 5.57848C15.5733 5.05848 16.4266 5.05848 16.9466 5.57848L19.5333 8.16514C20.04 8.68514 20.04 9.53848 19.52 10.0585Z",
    fill: "#14904A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrownPro);
export default __webpack_public_path__ + "static/media/crown-pro.8c5b4e1515e3229f55d144d3f5d8e8c0.svg";
export { ForwardRef as ReactComponent };